rdefine('app/products/collections/Languages',['backbone'],function(){
    var model = Backbone.Ribs.Model.extend({
        defaults:{
        }
    });

    return Backbone.Ribs.Collection.extend({
        model:model,
        initialize:function(els, options) {
           // this.on("select",this.onSelect.bind(this));
        },
        setActive:function(model) {
            _.each(this.models,function(m){
                m.set("active",false);
            });
            model.set("active",true);
        }
    });
});